enum Factors {
  SEA_FRONT_LENGTHS = 10,
  BACK_STREET_LENGTHS = 11,
}

export default Factors;
